import React from 'react';
import './SeparationLine.scss'; // Import the CSS file

const SeparationLine = () => {
  return <div className="separation-line"></div>;
};

export default SeparationLine;
